export default "__VITE_ASSET__BJtvDVtu__"